import { useCallback, useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { debounce } from "utils/utils";

export const QUERY_PARAM_NAME = "q";

export const useSearch = () => {
    const [searchParams, setSearchParams] = useSearchParams();
    const [prevPath, setPrevPath] = useState("");
    const [query, setQuery] = useState("");
    const q = searchParams.get(QUERY_PARAM_NAME) ?? "";

    const debouncedUpdate = useCallback(
        debounce((q: string) => {
            setQuery(q);
        }, 500),
        []
    );

    useEffect(() => {
        if (prevPath !== location.pathname) {
            setQuery(q);
            setPrevPath(location.pathname);
        } else if (q !== query) {
            debouncedUpdate(q);
        }
    }, [searchParams, location]);

    const clearSearch = () => {
        const params = new URLSearchParams(searchParams);
        params.delete(QUERY_PARAM_NAME);
        setSearchParams(params, { replace: true });
    };

    return { query, clearSearch };
};

// The current search query without debouncing, e.g. to attach it to tracked events
export const useSearchQuery = () => {
    const [searchParams] = useSearchParams();
    return searchParams.get(QUERY_PARAM_NAME) ?? undefined;
};
